import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
// Should look at lifting this to the Theme
const useStyles = createUseStyles({
  root: {},
  modeUp: {},
  modeDown: {
    transform: 'rotate(-180deg)'
  },
  modeLeft: {
    transform: 'rotate(-90deg)'
  },
  modeRight: {
    transform: 'rotate(90deg)'
  }
});

const ArrowSolidIcon = props => {
  const {
    mode,
    classes: classesProp,
    className: classNameProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, {
    [classes.modeUp]: mode === 'up',
    [classes.modeDown]: mode === 'down',
    [classes.modeLeft]: mode === 'left',
    [classes.modeRight]: mode === 'right'
  }, classNameProp);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M18.936 16H5.064c-.466 0-.79-.197-.968-.592-.18-.394-.107-.733.215-1.017l6.937-6.107C11.462 8.095 11.713 8 12 8s.538.095.752.284l6.937 6.107c.322.284.394.623.215 1.017-.18.395-.502.592-.968.592",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default ArrowSolidIcon;